import clienteAxios from "../config/axios";

export async function addTransactionDocument(tDoc, productList) {
  return clienteAxios.post(`/transactionDocument`, { transactionDocument: tDoc, products: productList });
}

export async function addTransactionDocumentDirect(transactionDocument, procProgramado, activo) {
  return clienteAxios.post(`/transactionDocumentDirect`, { transactionDocument, procProgramado, activo });
}

export async function addTransactionDocumentsFromCtrlsFallidos(procOriginal, ordenesTrabajo, procTemplate) {
  return clienteAxios.post(`/transactionDocumentFromCtrlsFallidos`, { procOriginal, ordenesTrabajo, procTemplate });
}

export async function addTransactionDocumentFromProcs(tDoc, productList, procsProgramados) {
  return clienteAxios.post(`/transactionDocumentFromProcs`, { transactionDocument: tDoc, products: productList, procsProgramados });
}

export async function getTransactionDocumentsByFilter(id) {
  return clienteAxios.get(`/transactionDocument/nrofor/${id}`);
}

export async function addFiles(formData) {
  return clienteAxios.post("/transactionDocument/file", formData, { headers: { "Content-Type": "multipart/form-data" }, timeout: 0 });
}

export async function updateTDoc(tDoc, updates, user) {
  return clienteAxios.put("/transactionDocument", { id: tDoc._id, updates, fecMod: tDoc.fecMod, user });
}

export async function deleteFile(fileName) {
  return clienteAxios.delete(`/transactionDocument/file/${fileName}`);
}

export async function deleteTDoc(nroFor, id, state) {
  return clienteAxios.delete(`/transactionDocument/${nroFor}/${id}/${state}`);
}


export async function getTDocByFilter(filtros) {
  return clienteAxios.post("/transactionDocument/filter", filtros);
}

export async function createPDF(tDocCodFor ,tDocNroFor, userId, withLogo, formato, cotizacionDolar) {
  return clienteAxios.post("/transactionDocument/informe", { tDocCodFor, tDocNroFor, userId, withLogo, formato, cotizacionDolar });
}

export async function getFiles(tDocCodFor, tDocNroFor) {
  return clienteAxios.get(`/transactionDocument/files/${tDocCodFor}/${tDocNroFor}`);
}

export async function sentToWebService(id, user){
  return clienteAxios.post("/transactionDocument/sendToWebService", { id, user });
}

export async function getTDocsByUserIdAndParams(userId, filtros){
  return clienteAxios.get(`/transactionDocument/${userId}${filtros}`);
}
export async function getTDocsByUserIdAndParamsReport(userId, filtros){
  return clienteAxios.get(`/transactionDocument/report/${userId}${filtros}`);
}

export async function getODTByNroFor(nrofor){
  return clienteAxios.get(`/transactionDocument/nrofor/${nrofor}`);
}

export async function getInfoDashboard(userId, filtros, filtrosEstado){
  return clienteAxios.post(`/transactionDocument/infoDashboard/${userId}${filtros}`,{filtrosEstado});
}

//ruta para que me triga el activo que contiene los trasdocuments

export async function getFilesActivos(activoCod ){
  return clienteAxios.get('/transactionDocuments/activo',  {
    params: { activoCod: activoCod.join(',') }
  });
}

